import { createContext, useContext, useState } from 'react';

interface LayoutCtx {
  promoVisible: boolean;
  dismissPromo: () => void;
}

const LayoutContext = createContext<LayoutCtx>({
  promoVisible: true,
  dismissPromo: () => {},
});

export function LayoutProvider({ children }: { children: React.ReactNode }) {
  const [promoVisible, setPromoVisible] = useState<boolean>(() => {
    const ts = localStorage.getItem('spartech_promo_dismissed');
    if (!ts) return true;
    return Date.now() - parseInt(ts, 10) > 86_400_000; // re-show after 24h
  });

  const dismissPromo = () => {
    localStorage.setItem('spartech_promo_dismissed', String(Date.now()));
    setPromoVisible(false);
  };

  return (
    <LayoutContext.Provider value={{ promoVisible, dismissPromo }}>
      {children}
    </LayoutContext.Provider>
  );
}

export function useLayout() {
  return useContext(LayoutContext);
}

/** Returns the correct top-padding class for pages */
export function usePageTop() {
  const { promoVisible } = useLayout();
  return promoVisible ? 'pt-[6.5rem]' : 'pt-16';
}
